// const url = 'https://www.planspiel-bw.de/?type=7777777&getjson=1';
const url = 'api/data';

export const getGameData = () => {
	return new Promise((resolve, reject) => {
		const interval = setInterval(async () => {
			try {
				const res = await fetch(url);
		
				if (!res.ok) {
					throw new Error(`error: ${res.status}`);

				}

				const data = await res.json();
				console.log(data);

				if (data.status === 'decision' || data.status === 'success' || data.status === 'start' || data.status === 'fail' || data.status === 'norestart') {
					// console.log('data sent')
					clearInterval(interval)
					resolve(data);
					// console.log(data.status);
				} else {
					console.log(data.status)
				}
			} catch(e) {
				clearInterval(interval);
				reject(e);
			}
		}, 2000)
	})
}

export const saveGameData = async (body) => {
	try {
		const res = await fetch(url, {method: 'POST', body});

		if (!res.ok) {
			throw new Error(`error: ${res.status}`);
		}

		const data = await res.json();

		return data;

	} catch(e) {
		console.log(e);
	}
}